// An action button placed in a note (Insert …, Sign). With structured
// capture it is the white button every input shares, one 20px line tall.
export function noteButtonClass(structured: boolean): string {
  return structured
    ? 'inline-flex h-5 items-center gap-1 rounded-sm border border-border bg-card px-1.5 align-top text-sm leading-[18px] text-foreground hover:bg-gray-460'
    : 'inline-flex items-center gap-1 rounded-xs border-[0.5px] border-gray-450 bg-gray-470 px-1 py-px hover:bg-gray-460'
}

// The button's label.
export function noteButtonLabelClass(structured: boolean): string {
  return structured ? 'text-foreground' : 'text-foreground-secondary'
}
